import axios from "axios";

export default appApi();

function appApi() {
  return {
    install: install
  };

  function install(Vue) {
    const appHttp = axios.create({
      baseURL:
        "https://sheets.googleapis.com/v4/spreadsheets/1EEcri8k5vnYlrm-6SrSqjVnrJ5R8aSbZPAsyzTDLktA"
    });

    appHttp.interceptors.response.use(
      response => response,
      catchAllResponseFailures
    );

    Vue.appApi = _appApi;

    function _appApi() {
      return {
        guest
      };
      // Vue.appApi().guest()
      function guest() {
        return {
          user,
          getServiceCount
          //recordService
        };

        // Vue.appApi().guest().user()
        function user() {
          return {
            getUser
          };

          // Vue.appApi().guest().user().getUser()
          function getUser() {
            return appHttp.get(`/wp-json/wp/v2/users/me`);
          }
        }

        // Vue.appApi().guest().getServiceCount()
        function getServiceCount() {
          return appHttp.get(
            `/values/C2/?key=AIzaSyBZeS-dyvgtFWlR2yJC-a9sbUe8NfJF_7M`
          );
        }

        // Vue.appApi().guest().recordService(payload)
        // function recordService(payload) {
        //   return appHttp.post(
        //     `/values/FormEntries!A1:append/?key=AIzaSyBZeS-dyvgtFWlR2yJC-a9sbUe8NfJF_7M`,
        //     payload
        //   );
        // }
      }
    }
    function catchAllResponseFailures(error) {
      var endpointNotSupported =
        error.response &&
        error.response.status === 410 &&
        error.response.data &&
        error.response.data.slug === "endpoint_obsolete";
      var errorStatusIsUnauthorized =
        error.response && error.response.status === 401;

      if (endpointNotSupported) {
        error.response.appMessage = "Endpoint not supported";
      }

      if (errorStatusIsUnauthorized) {
        error.response.appMessage = "Error status is unauthorized.";
      }

      if (error.response && error.response.statusText) {
        error.response.appMessage = error.response.statusText;
      }

      var errorHasMessageProperty =
        error.response && error.response.data && error.response.data.message;
      if (errorHasMessageProperty && error.response.data.message !== "") {
        error.response.appMessage += ": " + error.response.data.message;
      }

      var errorIsValidationError =
        error.response.status === 422 && error.response.data.errors;
      if (errorIsValidationError) {
        error.response.appMessage =
          "Validation Error: Check above and try again.";
      }

      return Promise.reject(error.response);
    }
  }
}
